import React from "react";

import { Connection } from "src/api/connectApi/types";
import { isBetaConnection } from "src/connections/CreateConnectionGrid";
import { getProviderDescription } from "src/connections/ProviderResourceProperties";
import { isCaseUpdateNodeConnection } from "src/connections/model/inboundWebhook";
import { NodeIcon as getNodeIcon } from "src/constants/NodeIcons";
import {
  CONNECTION_GROUP_PROPERTIES,
  getNodeTitle,
} from "src/constants/NodeProperties";
import { ConnectionGroupType, NODE_TYPE } from "src/constants/NodeTypes";
import { AddNodeCard } from "src/nodeAdding/AddNodeCard";
import { SubPaneLayout } from "src/nodeAdding/SubPaneLayout";

export type AddConnectionGroupPaneProps = {
  connections: Connection[];
  groupType: ConnectionGroupType;
  onBackButtonClick: () => void;
  onCloseButtonClick: () => void;
  onConnectionClick: (connection: Connection) => void;
};

export const AddConnectionGroupPane: React.FC<AddConnectionGroupPaneProps> = ({
  connections,
  groupType,
  onBackButtonClick,
  onCloseButtonClick,
  onConnectionClick,
}) => {
  return (
    <SubPaneLayout
      title={CONNECTION_GROUP_PROPERTIES[groupType].HEADER}
      onBackButtonClick={onBackButtonClick}
      onCloseButtonClick={onCloseButtonClick}
    >
      <div>
        {connections.map((connection) => {
          const isCaseUpdate = isCaseUpdateNodeConnection(connection);
          return (
            <AddNodeCard
              key={connection.id}
              dataLoc={`add-${connection.provider}-${connection.id}`}
              description={getProviderDescription(connection)}
              isBeta={isBetaConnection(connection.provider)}
              nodeIcon={
                isCaseUpdate
                  ? getNodeIcon({ nodeType: NODE_TYPE.CASE_UPDATE_NODE })
                  : getNodeIcon({ nodeType: NODE_TYPE.CASE_CREATION_NODE })
              }
              title={
                isCaseUpdate
                  ? getNodeTitle({ nodeType: NODE_TYPE.CASE_UPDATE_NODE })
                  : getNodeTitle({ nodeType: NODE_TYPE.CASE_CREATION_NODE })
              }
              onClick={() => onConnectionClick(connection)}
            />
          );
        })}
      </div>
    </SubPaneLayout>
  );
};
